import { useState } from 'react';
import { useRouteParams } from '../../../../../infra/routing';
import { useApiQuery } from '../../../../../infra/api';
import { endpoints } from '../network/endpoints';
export var useBarberSelectorHandlers = function () {
    var params = useRouteParams();
    var _a = useApiQuery({
        endpoint: endpoints.shopDetailsQuery,
        payload: {
            shopId: params.id,
        },
    }), shop = _a.data, isLoadingShop = _a.isLoading;
    var _b = useState(null), selectedBarberId = _b[0], setSelectedBarberId = _b[1];
    var handleSelectedBarberChanged = function (e) {
        setSelectedBarberId(e.currentTarget.value);
    };
    return {
        shop: shop,
        isLoadingBarberData: isLoadingShop,
        barbers: (shop === null || shop === void 0 ? void 0 : shop.barbers) || [],
        selectedBarberId: selectedBarberId,
        onSelectedBarberChanged: handleSelectedBarberChanged,
    };
};
